import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import searchAgentView from 'views/management/quotaRetraction/search'; // Importing searchAgentView component
import transfersDetail from 'views/management/quotaRetraction/Retraction'; // Importing transfersDetail component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * QuotaRetractionView class extends JetView to create a specific view for quota retraction.
 */
export default class QuotaRetractionView extends JetView {
    /**
     * Configures the UI components of the QuotaRetractionView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Right panel configuration
        const right = {
            type: 'wide',
            rows: [],
        };

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: 1000, // Number of items per page
                },
            ],
        };

        // Left panel configuration
        const left = {
            Width: 250,
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme, // Apply the current theme
                    elements: [
                        {
                            view: 'label', // Label for the toolbar
                            align: 'center',
                            label: _('Realizar Retracción'), // Localized label text
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                {
                                    view: 'icon', // Icon button for closing
                                    icon: 'wxi-close', // Icon type
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Click event to navigate to dashboard
                                },
                            ],
                        },
                    ],
                },
                transfersDetail, // Including transfersDetail component
                toolbar, // Including the toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Return the main configuration object for the view
        return {
            type: 'wide',
            responsive: true,
            cols: [
                left, // Include the left panel in the main layout
            ],
        };
    }
}

// FILE DOCUMENTED
